import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MenuIcon from "@material-ui/icons/Menu";
import Box from "@material-ui/core/Box";
import DefaultLogo from "../../../../../assets/images/defaultLogo.png";
import MobileNavDrawer from "./mobile-navbar";
import Button from "@material-ui/core/Button";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { thumborImageUrl } from "../../../../../Utility";
import Menu from "@material-ui/core/Menu";

const useStyles = makeStyles((theme) => ({
  navbar: {
    height: "122px",
    width: "100%",
    backgroundColor: "transparent",
    display: "flex",
    alignItems: "center",
    position: "sticky",
    top: "0",
    zIndex: "999",
  },
  contentText: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.text.link_text_color,
    marginRight: "50px",
    cursor: "pointer",
    zIndex: "5",
    paddingLeft: "8px",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
    [theme.breakpoints.down("md")]: {
      marginRight: "22px",
    },
  },
  contentTextDrop: {
    fontWeight: 500,
    fontSize: "16px",
    color: theme.agentTheme.text.link_text_color,
    cursor: "pointer",
    zIndex: "5",
    paddingLeft: "8px",
    "&:hover": {
      color: theme.agentTheme.primary.main,
    },
  },
  logoImg: {
    height: "70px",
    width: "auto",
    marginLeft: "30px",
    marginRight: "39px",
    cursor: "pointer",
  },
  menuBox: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "9px",
    height: "505px",
    width: "400px",
  },
  menuLogo: {
    height: "40.3px",
    width: "auto",
  },
  usernameText: {
    fontSize: "16px",
    marginTop: "12px",
    color: theme.agentTheme.primary.main,
    cursor: "pointer",
    fontWeight: 600,
  },
}));

export default ({ websiteData = {}, widgetList = [] }) => {
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showKnowMore, setShowKnowMore] = useState(null);
  const [showLoginDropDown, setShowLoginDropDown] = useState(false);

  let {
    username = "",
    memberProfile = null,
    userProfileData = {},
    handleLogout = () => {},
    isLoggedIn = false,
    content_arr: contentArr = [],
    deskTopView = true,
  } = websiteData || {};
  let { logo_url = "" } = memberProfile;
  const classes = useStyles();
  let { userName = "" } = userProfileData || {};
  let [{ component: LoginComponent = null } = {}] = widgetList.filter(
    (widget) => widget.id == "loginModal"
  );
  let [loginObj] = contentArr.filter((obj) => obj.name == "Login");
  let updatedContentArr = contentArr.filter((obj) => obj.name != "Login");

  const handleClickLogin = (event) => {
    setShowLoginDropDown(event.currentTarget);
  };

  const handleCloseLogin = () => {
    setShowLoginDropDown(null);
  };
  const DropDownType = ({ isBtn = false, items = [] }) => {
    let { name = "", link = "", id = "" } = items;
    if (id == "logout") {
      return <MenuItem onClick={handleLogout}>{name}</MenuItem>;
    } else if (link) {
      return (
        <MenuItem
          style={{
            textTransform: "capitalize",
          }}
          component={"a"}
          href={link}
        >
          {name}
        </MenuItem>
      );
    } else {
      return <MenuItem>{name}</MenuItem>;
    }
  };

  const handleClick = (event) => {
    setShowKnowMore(event.currentTarget);
  };

  const handleClose = () => {
    setShowKnowMore(null);
  };

  if (!deskTopView) {
    return (
      <Box
        display="flex"
        alignItems="center"
        style={{
          padding: "20px 14px",
        }}
      >
        <MenuIcon
          color="card.foreground"
          onClick={() => setShowMenuDrawer(true)}
        />
        <MobileNavDrawer
          widgetList={widgetList}
          websiteData={websiteData}
          showDrawer={showMenuDrawer}
          setShowDrawer={setShowMenuDrawer}
          contentArr={contentArr}
        />
        <Box
          display="flex"
          justifyContent="center"
          marginLeft={!deskTopView ? "28%" : "0px"}
        >
          <img
            src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
            className={classes.menuLogo}
            onClick={() => {
              window.location.href = `/${username ? `${username}` : ""}`;
            }}
          />
        </Box>
      </Box>
    );
  }
  let { dropDownItem = [] } = loginObj;
  return (
    <>
      {deskTopView && (
        <div className={`${classes.navbar}`}>
          <Box marginRight="39px">
            <img
              className={classes.logoImg}
              src={logo_url ? thumborImageUrl(logo_url, 0, 100) : DefaultLogo}
              onClick={() => {
                window.location.href = `/${username ? `${username}` : ""}`;
              }}
            />
          </Box>
          <Box display="flex" justifyContent="space-around" width="100%">
            <Box display="flex">
              {updatedContentArr.map((item) => {
                let {
                  isDropdown = false,
                  isBtn = false,
                  dropDownItem = [],
                  id = "",
                } = item;
                return isDropdown ? (
                  <Box
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <Box
                      aria-controls="simple-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                      display={"flex"}
                      alignItems={"center"}
                    >
                      <a
                        href={item.link}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                        }}
                        className={classes.contentTextDrop}
                      >
                        {item.name}
                        <ExpandMoreIcon
                          style={{
                            color: "inherit",
                          }}
                        />
                      </a>
                    </Box>
                    <Menu
                      getContentAnchorEl={null}
                      anchorOrigin={{
                        vertical: "bottom",
                      }}
                      transformOrigin={{
                        vertical: "top",
                      }}
                      anchorEl={showKnowMore}
                      keepMounted
                      open={Boolean(showKnowMore)}
                      onClose={handleClose}
                    >
                      {dropDownItem.map((items) => {
                        let { isBtn = false } = items;
                        return <DropDownType items={items} isBtn={isBtn} />;
                      })}
                    </Menu>
                  </Box>
                ) : (
                  <Box display="flex" alignItems="center">
                    <a href={item.link} className={classes.contentText}>
                      {item.name}
                    </a>
                  </Box>
                );
              })}
            </Box>
            <Box className={classes.loginBtn}>
              <Box>
                {isLoggedIn ? (
                  <div class="dropdown">
                    <Box
                      display={"flex"}
                      flexDirection={"column"}
                      alignItems={"center"}
                      justifyContent={"center"}
                    >
                      <Box display={"flex"} onClick={handleClickLogin}>
                        <Typography class={classes.usernameText}>
                          {" "}
                          {`Hi ${userName}`}
                        </Typography>
                        <Box display={"flex"} alignItems={"center"}>
                          <ExpandMoreIcon color="primary" />
                        </Box>
                      </Box>
                      <Menu
                        getContentAnchorEl={null}
                        anchorOrigin={{
                          vertical: "bottom",
                        }}
                        transformOrigin={{
                          vertical: "top",
                        }}
                        anchorEl={showLoginDropDown}
                        keepMounted
                        open={Boolean(showLoginDropDown)}
                        onClose={handleCloseLogin}
                        className={classes.dropdownContainerLogin}
                      >
                        {dropDownItem.map((items) => {
                          let { isBtn = false } = items;
                          return <DropDownType items={items} isBtn={isBtn} />;
                        })}
                      </Menu>
                    </Box>
                  </div>
                ) : (
                  <Button
                    variant="outlined"
                    style={{
                      width: "135px",
                    }}
                    color="primary"
                    onClick={() => setShowLogin(true)}
                  >
                    Login
                  </Button>
                )}
              </Box>
            </Box>
            {showLogin && (
              <LoginComponent onClose={() => setShowLogin(false)} />
            )}
          </Box>
        </div>
      )}
    </>
  );
};
